// ABOUTME: Path-specific mock data for TechLog -> RAAS completed flight transformation.
import { TechlogTruckUnit } from '../../../../types/techLog/fuel';
import { TechlogFlightStatus } from '../../../../types/techLog/sector';
import type { TechlogToRaasFlightInput } from './validation';

export const mockData: TechlogToRaasFlightInput = {
  techlog: {
    sector: {
      id: 'sector-raas-001',
      tripId: 'trip-raas-001',
      departureAirportId: 1,
      arrivalAirportId: 2,
      actualArrivalAirportId: 2,
      pilotInCommandId: 'pilot-1',
      secondInCommandId: 'pilot-2',
      offblocksTime: '2026-03-08T10:50:00.000Z',
      takeoffTime: '2026-03-08T11:00:00.000Z',
      landingTime: '2026-03-08T12:00:00.000Z',
      onblocksTime: '2026-03-08T12:12:00.000Z',
      status: TechlogFlightStatus.COMPLETE,
      createdAt: '2026-03-08T10:00:00.000Z',
      updatedAt: '2026-03-08T12:15:00.000Z',
      date: '2026-03-08',
      apuSeconds: 900,
      landingsCount: 1,
      takeoffsCount: 1,
      cycles: {
        airframe: 1,
        engine_1: 1,
        engine_2: 1,
        apu: 1,
      },
      preflightCustomData: {},
      postflightCustomData: {},
      passengersMale: 1,
      passengersFemale: 2,
      passengersChildren: 0,
      passengersInfants: 0,
      baggageWeight: 120,
      attachments: [],
    },
    trip: {
      id: 'trip-raas-001',
      aircraftId: 'aircraft-raas-001',
      date: '2026-03-08',
      number: 701,
      callsign: 'TF701',
      attachments: [],
      createdAt: '2026-03-08T09:45:00.000Z',
      updatedAt: '2026-03-08T12:15:00.000Z',
    },
    aircraft: {
      id: 'aircraft-raas-001',
      operatorId: 'techlog-op-123',
      aircraftTypeId: 'aircraft-type-raas-001',
      serialNumber: '145445',
      registration: 'VQ-TAB',
      year: 2008,
      fuelUnit: 'kg',
      oilUnit: 'ml',
      maxFuelValue: 5000,
      monthlyCycles: 10,
      monthlyFlightSeconds: 36000,
      monthlyApuSeconds: 1200,
      maintenanceType: 'hours',
      apuMode: 'installed',
      flightStatus: 'onGround',
      createdAt: '2026-01-01T00:00:00.000Z',
      updatedAt: '2026-03-08T09:45:00.000Z',
      aircraftType: {
        id: 'aircraft-type-raas-001',
        engineCount: '2',
        engineType: 'jet',
        weightCategory: 'light',
      },
    },
    airportDeparture: {
      id: 1,
      icaoCode: 'MYNN',
      iataCode: 'NAS',
      latitude: '25.0390',
      longitude: '-77.4662',
    },
    airportArrival: {
      id: 2,
      icaoCode: 'MYNN',
      iataCode: 'NAS',
      latitude: '25.0390',
      longitude: '-77.4662',
    },
    fuelUplifts: [
      {
        id: 'fuel-uplift-1',
        associatedRecordId: 'sector-raas-001',
        associatedRecordType: 'Flight',
        aircraftId: 'aircraft-raas-001',
        aircraftValuePreUplift: 1200,
        aircraftValuePostUplift: 1800,
        aircraftValueActualUplift: 600,
        truckActualUplift: 620,
        truckUnit: TechlogTruckUnit.LITER,
        density: 0.8,
        fuelType: 'JET-A1',
        safPercentage: 0,
        aircraftPlannedDeparture: 1800,
        priceValue: 1.2,
        priceCurrency: 'USD',
        paid: true,
        aircraftUnit: 'kg',
        createdAt: '2026-03-08T10:40:00.000Z',
        updatedAt: '2026-03-08T10:45:00.000Z',
      },
    ],
    fluidUplifts: [
      {
        id: 'fluid-uplift-engine-1',
        category: null,
        adjustment: null,
        uplift: 500,
        associatedRecordId: 'sector-raas-001',
        associatedRecordType: 'Flight',
        fluidType: 'oil',
        fluidDestination: 'engine',
        fluidDestinationNumber: 1,
        upliftUnit: 'ml',
        aircraftId: 'aircraft-raas-001',
        initialValue: null,
        departureValue: null,
        hydraulicCircuitId: null,
        attachments: [],
        createdAt: '2026-03-08T10:30:00.000Z',
        updatedAt: '2026-03-08T10:30:00.000Z',
      },
      {
        id: 'fluid-uplift-engine-2',
        category: null,
        adjustment: null,
        uplift: 1,
        associatedRecordId: 'sector-raas-001',
        associatedRecordType: 'Flight',
        fluidType: 'oil',
        fluidDestination: 'engine',
        fluidDestinationNumber: 2,
        upliftUnit: 'qt',
        aircraftId: 'aircraft-raas-001',
        initialValue: null,
        departureValue: null,
        hydraulicCircuitId: null,
        attachments: [],
        createdAt: '2026-03-08T10:31:00.000Z',
        updatedAt: '2026-03-08T10:31:00.000Z',
      },
      {
        id: 'fluid-uplift-apu-1',
        category: null,
        adjustment: null,
        uplift: 250,
        associatedRecordId: 'sector-raas-001',
        associatedRecordType: 'Flight',
        fluidType: 'oil',
        fluidDestination: 'apu',
        fluidDestinationNumber: 1,
        upliftUnit: 'ml',
        aircraftId: 'aircraft-raas-001',
        initialValue: null,
        departureValue: null,
        hydraulicCircuitId: null,
        attachments: [],
        createdAt: '2026-03-08T10:32:00.000Z',
        updatedAt: '2026-03-08T10:32:00.000Z',
      },
    ],
  },
  raas: {
    aircraftStatus: {
      serialNumber: '145445',
      resultType: 'Aircraft',
      partNumber: 'EMB-145LR',
      partDescription: 'EMB-145LR',
      registrationNumber: 'VQ-TAB',
      serviceable: true,
      hsn: 1200,
      csn: 500,
      asOfUTC: '2026-03-08T12:15:00.000Z',
      lastFlightFlownUTC: '2026-03-08T12:00:00.000Z',
      parked: false,
      serviceableReason: null,
      unserviceableReason: null,
      currentLocation: 'NAS',
      homeBase: 'NAS',
      dispatchHours: 0,
      dispatchDays: 0,
      dispatchCycles: 0,
      utilizationHours: 0,
      utilizationCycles: 0,
      utilizationPerUnits: 'Hours',
      accessorySTT: [
        {
          partDescription: 'Rolls Royce Engine',
          partNumber: 'AE3007A1',
          serialNumber: 'CAE-312463',
          position: 'LH',
          inheritsTime: true,
          mapTypeAPI: 'Engine',
          mapPositionAPI: 1,
          label: 'Ldg',
        },
        {
          partDescription: 'Rolls Royce Engine',
          partNumber: 'AE3007A1',
          serialNumber: 'CAE-311353',
          position: 'RH',
          inheritsTime: true,
          mapTypeAPI: 'Engine',
          mapPositionAPI: 2,
          label: 'Ldg',
        },
        {
          partDescription: 'APU',
          partNumber: '4504113A',
          serialNumber: 'SP-E0414728',
          position: '',
          inheritsTime: true,
          mapTypeAPI: 'APU',
          mapPositionAPI: 1,
          label: 'Ldg',
        },
        {
          partDescription: 'SHOCK ABSORBER ASSY',
          partNumber: '2309-2005-007',
          serialNumber: '10153',
          position: 'RH MLG',
          inheritsTime: false,
          mapTypeAPI: '',
          mapPositionAPI: 0,
          label: 'Ldg',
        },
      ],
      inputFields: [],
    },
  },
};
